const BASE_URL = process.env.REACT_APP_BASE_URL

// Auth endpoints
export const endpoints = {
  GET_STARTED_API: BASE_URL + "api/register",
  REGISTER_API: BASE_URL + "api/complete-register",
  LOGIN_API: BASE_URL + "api/login",
  LOGOUT_API: BASE_URL + "api/logout",
  API_URL: BASE_URL + "api/app-url",
  RESEND_API: BASE_URL + "api/email/resend-verification-email",
  FORGET_PASSWORD_API: BASE_URL + "api/forgot-password",
  CHANGE_PASSWORD_API: BASE_URL + "api/reset-password",
  APP_URL_CHECK_API: BASE_URL + "api/check-app-url",
  CREATE_TEAM: BASE_URL + "api/create-team",
  GET_TEAM: BASE_URL + "api/get-team-member",
  UPDATE_TEAM: BASE_URL + "api/update-user-status",
  UPDATE_PASSWORD: BASE_URL + "api/update-user-password",
  CREATE_JOB_POST: BASE_URL + "api/create-job-posting",
  GET_JOB_POST:BASE_URL+"api/get-all-jobs",
  GET_SKILLS:BASE_URL+"api/get-skills",
  GET_INDSUTRY:BASE_URL+"api/get-industries",
  WRITE_WITH_AT:BASE_URL+"api/write-with-gemini",
  PROFILE_API:BASE_URL+'api/update-profile',
  PROFILE_PICTURE_DELETE_API:BASE_URL+"api/delete-picture",
  UPDATE_PASSWORD_API:BASE_URL+"api/change-password",
  GET_USER_DETAILS_API:BASE_URL+"api/get-user",
  GET_APPLICANTS:BASE_URL+"api/new-candidate",
  GET_PASSIVE_CANDIDATES:BASE_URL+"api/passive-candidate",
  GET_RESUMES_API:BASE_URL+"api/get-resumes",
  UPLOAD_API:BASE_URL+"api/upload-resume",
   DOWNLOAD_API:BASE_URL+"api/download-business-resume",
  VIEW_RESUME_API:BASE_URL+"api/view-business-resume",
  RESUMES_API:BASE_URL+"api/resumes-detail",
   GET_SKILL_LIST_API:BASE_URL+"api/get-skills",
  GET_COMPANIES_LIST_API:BASE_URL+"api/get-companies",
  GET_INDUSTRIES_LIST_API:BASE_URL+'api/get-industries', 
  CREATE_NOTES:BASE_URL+"api/add-notes",
  GET_NOTES:BASE_URL+"api/get-notes",
  GET_LOCATION:BASE_URL+"api/get-locations",
  GET_NOTIFICATIONS:BASE_URL+"api/get-notification",
  MARK_AS_READ_NOTIFICATION:BASE_URL+"api/read-notification",
  SAVE_SEARCH_API:BASE_URL+"api/save-resume-search",
  GET_SAVE_SEARCH:BASE_URL+"api/get-resume-search",
  GENERATE_CAREER_LINK:BASE_URL+"api/jobs-embed-generate-token",
  GET_CAREER_PAGE_JOBS:BASE_URL+"api/list-carrer-job",
  GET_CAREER_PAGE_JOB_VIEW:BASE_URL+"api/view-job-posting-carrer",
  GET_PRICE_PER_USER:BASE_URL+"api/pricing-per-user",
  SUBSCRIBE_PLAN:BASE_URL+"api/subscribe",
  GET_SUBSCRIBE_DETAIL:BASE_URL+"api/payment-history",
  CHANGE_STATUS:BASE_URL+"api/change-resume-status",
  EMBED_JOB_APPLY:BASE_URL+"api/apply-job",
  DASHBOARD_DATA:BASE_URL+"api/get-dashboard-data"
}

